// ** Redux
import { createSlice } from "@reduxjs/toolkit";

// ** Actions
import { getGallery } from "./get-gallery.action";

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	success: false,
	error: false,
	data: [],
	pagination: {
		currentpage: 1,
		totalpages: 1,
	},
	minDates: {
		minYear: null,
		minMonth: null,
	},
	fromServer: false,
};

// ############################################################

// Slice
const galleriesVideosSlice = createSlice({
	name: "mainPages/galleriesVideos",
	initialState,
	reducers: {
		resetGallery: () => {
			return {
				...initialState,
			};
		},
	},
	extraReducers: (builder) => {
		builder
			// getGallery
			.addCase(getGallery.pending, (state, action) => {
				if (action.meta.siteName === "galleriesVideos") {
					state.loading = true;

					const isInfinityScroll = action.meta.infinityScroll;
					if (!isInfinityScroll) {
						state.data = [];
						state.pagination = {
							currentpage: 1,
							totalpages: 1,
						};
					}
				}
			})
			.addCase(getGallery.fulfilled, (state, action) => {
				if (action.payload.siteName === "galleriesVideos") {
					if (action.payload.infinityScroll) {
						const newDataGalleryHome = [
							...state.data,
							...(action.payload.media ?? []),
						];

						const newDataGalleryHomeFiltered =
							newDataGalleryHome.filter((val, id) => {
								return (
									id ===
									newDataGalleryHome.findIndex(
										(el) => el.id === val.id
									)
								);
							});

						state.data = newDataGalleryHomeFiltered;
					} else {
						state.data = action.payload.media ?? [];
					}

					state.loading = false;
					state.loaded = true;
					state.success = true;
					state.error = false;
					state.pagination = {
						currentpage:
							action.payload.pagination?.currentpage ?? 1,
						totalpages: action.payload.pagination?.totalpages ?? 1,
					};

					// ** Możliwe że jest to zbędne bo ustawiamy mindates w filters.period.startDate
					state.minDates = {
						minYear:
							action.payload.min_dates?.year ||
							state.minDates.minYear,
						minMonth:
							action.payload.min_dates?.month ||
							state.minDates.minMonth,
					};
				}
			})
			.addCase(getGallery.rejected, (state, action) => {
				if (action.meta.siteName === "galleriesVideos") {
					state.loading = false;
					state.loaded = true;
					state.success = false;
					state.error = true;
				}
			});
	},
});

// ############################################################

export const { setSearchSex, resetGallery } = galleriesVideosSlice.actions;

export default galleriesVideosSlice.reducer;

// ############################################################
